<div *ngIf="loadingprogress" class="w3-modal">
    <div class="w3-modal-content">
        <img style="width: 100%; height: 100%;" src="../../../assets/img/loader.svg" alt="No Image Available">
    </div>
</div>